import RejectReview from './RejectReview';

export default RejectReview;
